
import { Action } from '@ngrx/store';
import { dcmusuario } from 'src/app/models/SicarMap/dcmusuario.model';


export const SET_RangoMP = '[MODELOS] Set RangoMP';
export const SET_RangoMP_SUCCESS = '[MODELOS] Set RangoMP Succes';
export const SET_RangoMP_FAILURE = '[MODELOS] Set RangoMP Failure';


export class SetRangoMPAction implements Action {
  readonly type = SET_RangoMP;
  constructor(public rangosMP: dcmusuario[]) {}
}
export class SetRangoMPSuccesAction implements Action {
  readonly type = SET_RangoMP_SUCCESS;
  constructor() {}
}
export class SetRangoMPFailureAction implements Action {
  readonly type = SET_RangoMP_FAILURE;
  constructor(public error: any) {
  }
}

export type RangoMPActions =
  | SetRangoMPAction
  | SetRangoMPSuccesAction
  | SetRangoMPFailureAction;